import * as Sentry from "@sentry/react";
import { toast } from "react-toastify";

export const CARD_SUBMIT_FAILURE_MESSAGE =
  "Não foi possível concluir o envio do cartão. Tente novamente.";

export const reportCardSubmitFailure = (error: unknown) => {
  Sentry.withScope(scope => {
    scope.setTag("flow", "card_submit");
    Sentry.captureException(error);
  });
  toast.error(CARD_SUBMIT_FAILURE_MESSAGE);
};
